import {
  Text,
  BorderRadius,
  Breakpoints,
  Colors,
  Inset,
  Media,
  Spacing,
} from '@doordash/design-language'
import styled from 'styled-components'
import {
  COLOR_LEGAL_LINK,
  SIGNUP_FORM as Style,
} from '../../../landing/constants'

export const LegalLink = styled.a`
  color: ${COLOR_LEGAL_LINK};
  text-decoration: underline;
  white-space: nowrap;
`

export const LegalText = styled(Text)`
  letter-spacing: ${Style.LEGAL_TEXT.LETTER_SPACING};
`

export const Container = styled.div`
  border-radius: ${BorderRadius.Medium}px;
  border: none;
  background: white;
  overflow: hidden;
  max-width: 30rem;
  padding: 24px;
`

export const TitleWrapper = styled.div`
  text-align: center;
`

export const SplitSection = styled.div`
  ${Media.Mobile`
    & > * + * {
      margin-top: ${Spacing.Small}px;
    }
  `};
  @media (min-width: ${Breakpoints.Mobile}px) {
    display: flex;
    justify-content: space-between;
    width: 100%;

    > * {
      flex: 1 1 auto;
      max-width: calc(50% - 0.75rem);
    }
  }
`

SplitSection.displayName = 'SplitSection'

export const Disclaimer = styled.div`
  background: #f8f8f8;
  padding: 1rem;
  border-radius: ${BorderRadius.Small}px;
`

Disclaimer.displayName = 'Disclaimer'

export const FormTitle = styled.div`
  font-size: 20px;
  text-align: center;
  margin: 0 auto 3rem;

  &:empty {
    margin: 0;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
    margin: 1rem 0 1.5rem;
  }
`

export const Error = styled(Inset)`
  text-align: center;
  background-color: ${Colors.WarningBackground};
`

export const H3 = styled.h3`
  margin: 0;
`
